<template>
  <g class="CS">
    <path d="m 6.23,0.5 c -1.1,0 -2,0.9 -2,2 v 13 h 4 v -13 c 0,-1.1 -0.9,-2 -2,-2 z" class="st0" fill="#C7C7C7" stroke="#FFFFFF" stroke-linejoin="round"/>
    <path d="m 16.23,0.5 c -1.1,0 -2,0.9 -2,2 v 13 h 4 v -13 c 0,-1.1 -0.9,-2 -2,-2 z" class="st0" fill="#C7C7C7" stroke="#FFFFFF" stroke-linejoin="round"/>
    <rect height="53" width="20" class="st1" y="7.5" x="1.15" :fill="color" stroke="#FFFFFF" stroke-width="1.0508" stroke-linejoin="round"/>
    <rect height="15" width="14" class="st2" y="9.5" x="4.23" :fill="color" stroke="#FFFFFF" stroke-linejoin="round"/>
    <rect height="15" width="14" class="st2" y="32.5" x="4.23" :fill="color" stroke="#FFFFFF" stroke-linejoin="round"/>
    <line y2="24.5" x2="21.23" y1="24.5" x1="1.23" class="st3" fill="none" stroke="#FFFFFF" stroke-linejoin="round"/>
    <line y2="32.5" x2="20.73" y1="32.5" x1="0.73000002" class="st3" fill="none" stroke="#FFFFFF" stroke-linejoin="round"/>
    <path fill="#ebebeb" stroke="#FFFFFF" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" d="M 16.46,126.35 H 16.5 V 106.37 L 20.46,103 h 0.05 V 57.99 H 20.48 L 13.52,53.83 V 10.12 L 14.17,9.46 V 7.01 h -6.3 v 2.46 l 0.65,0.66 v 43.71 0 L 1.56,58 h 0.01 v 44.92 0 0 0.07 h 0.04 l 3.88,3.38 H 5.5 v 19.97 h 0.04 c -1.88,2.44 -5.04,5.79 -5.04,9.5 0,4.87 2.01,9.13 5.02,11.5 h 2.26 l 0.5,-2 h 2 v 0 h 2 v 0 h 1.44 l 0.5,2 h 2.26 c 3.01,-2.37 5.02,-6.63 5.02,-11.5 0,-3.7 -3.16,-7.05 -5.04,-9.49 z" class="st4"/>
    <rect fill="#ebebeb" stroke="#FFFFFF" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" height="8" width="4" class="st4" y="91.5" x="14.870001" />
    <rect fill="#ebebeb" stroke="#FFFFFF" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" height="8" width="4" class="st4" y="91.5" x="3.23" />
    <line y2="129.28" x2="15.05" y1="129.28" x1="6.5500002" class="st5" fill="none" stroke="#FFFFFF" stroke-linecap="round" stroke-linejoin="round"/>
    <line y2="141.78" x2="18.790001" y1="141.78" x1="3.2" class="st5" fill="none" stroke="#FFFFFF" stroke-linecap="round" stroke-linejoin="round"/>
    <line y2="134.78" x2="15.05" y1="134.78" x1="6.5500002" class="st5" fill="none" stroke="#FFFFFF" stroke-linecap="round" stroke-linejoin="round"/>
    <line y2="118.05176" x2="8.9400005" y1="118.05176" x1="4.9699998" class="st5" fill="none" stroke="#FFFFFF" stroke-linecap="round" stroke-linejoin="round"/>
    <line y2="118.05176" x2="17.130001" y1="118.05176" x1="13.160001" class="st5" fill="none" stroke="#FFFFFF" stroke-linecap="round" stroke-linejoin="round"/>
    <line y2="89.779999" x2="9.2800007" y1="118.0178" x1="9.2800007" class="st5" fill="none" stroke="#FFFFFF" stroke-linecap="round" stroke-linejoin="round"/>
    <line y2="89.779999" x2="12.92" y1="118.0178" x1="12.92" class="st5" fill="none" stroke="#FFFFFF" stroke-linecap="round" stroke-linejoin="round"/>
    <rect fill="#ebebeb" stroke="#FFFFFF" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" height="28.5" width="10" class="st4" y="61" x="6.23" />
  </g>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "CsPlug",
  props: {
    plugColor: String,
    x: Number,
    y: Number,
    flip: Boolean,
    clip: Boolean,
  },
  data() {
    return {
      plugWidth: 30,
      plugHeight: 10,
    };
  },
  computed: {
    color() {
      return this.getColor(this.plugColor);
    },
    yRecalculated() {
      return this.y - this.plugHeight / 2;
    },
    ...mapGetters(["getCssColor"]),
  },
  methods: {
    getColor(colorName) {
      return this.getCssColor(colorName);
    },
    getNoseColor(colorName) {
      return this.getCssColor(colorName + "Nase");
    },
  },
};
</script>

<style>
.st0{fill:#C7C7C7;stroke:#FFFFFF;stroke-linejoin:round;}
	.st1{stroke:#FFFFFF;stroke-width:1.0508;stroke-linejoin:round;}
	.st2{stroke:#FFFFFF;stroke-linejoin:round;}
	.st3{fill:none;stroke:#FFFFFF;stroke-linejoin:round;}
	.st4{fill:#ebebeb;stroke:#FFFFFF;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}
	.st5{fill:none;stroke:#FFFFFF;stroke-linecap:round;stroke-linejoin:round;}
</style>